<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
            class="menu-icon"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center d-flex flex-grow-1 d-lg-flex">
      <div>
        <b-tooltip
          target="refresh_cache"
          triggers="hover"
          variant="primary"
          :boundary="boundary"
        >
          Clear App Cache
        </b-tooltip>
        <div
          id="refresh_cache"
          @click="refreshCache"
        >
          <img
            class="cursor-pointer mr-2"
            src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1wYWludGJydXNoIj48cGF0aCBkPSJNMTguMzcgMi42MyAxNCA3bC0xLjU5LTEuNTlhMiAyIDAgMCAwLTIuODIgMEw4IDdsOSA5IDEuNTktMS41OWEyIDIgMCAwIDAgMC0yLjgyTDE3IDEwbDQuMzctNC4zN2EyLjEyIDIuMTIgMCAxIDAtMy0zWiIvPjxwYXRoIGQ9Ik05IDhjLTIgMy00IDMuNS03IDRsOCAxMGMyLTEgNi01IDYtNyIvPjxwYXRoIGQ9Ik0xNC41IDE3LjUgNC41IDE1Ii8+PC9zdmc+"
          >
        </div>
      </div>
      <network-speed />
    </div>

    <div
      class="bookmark-wrapper business-title align-items-center flex-grow-1 d-none d-lg-flex"
      style="z-index:-1"
    >
      <!-- <b><p>{{ currentUser.merchant_name }}</p></b> -->
      <table>
        <tr><b class="nav-text">{{ form.company_name }}</b></tr>
      </table>
    </div>
    <div class="navbar-scrollable">
      <b-navbar-nav class="nav align-items-center ml-auto">
        <dsr />
        <general-search />
        <notification-dropdown />
        <waybill />
      </b-navbar-nav>
    </div>
    <div>
      <b-navbar-nav class="nav align-items-center ml-auto">
        <b-nav-item-dropdown
          right
          toggle-class="d-flex align-items-center dropdown-user-link"
          class="dropdown-user"
        >
          <template #button-content>
            <b-avatar
              size="40"
              variant="light-primary"
              badge
              :src="require('@/assets/images/avatars/4-small.png')"
              class="badge-minimal mobile-avatar"
              badge-variant="success"
            />
          </template>
          <b-dropdown-item class="no-hover">
            <div class="d-flex align-items-center">
              <b-avatar
                size="45"
                variant="light-primary"
                badge
                :src="require('@/assets/images/avatars/4-small.png')"
                class="badge-minimal mr-2"
                badge-variant="success"
              />
              <div>
                <p class="user-name font-weight-bolder mb-0">
                  {{ currentUser ? currentUser.first_name : '' }} {{ currentUser ? currentUser.last_name : '' }}
                </p>
                <div class="user-details">
                  <span class="user-status d-block">{{ currentUser ? currentUser.user_name : '' }}</span>
                  <span class="user-status d-block">{{ currentUser ? currentUser.role.name : '' }}</span>
                </div>
              </div>
            </div>
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item
            link-class="d-flex align-items-center"
            @click="toggleTheme"
          >
            <feather-icon
              size="16"
              class="mr-50"
              :icon="`${isDark ? 'Sun' : 'Moon'}Icon`"
            />
            <span>{{ isDark ? 'Light Mode' : 'Dark Mode' }}</span>
          </b-dropdown-item>

          <b-dropdown-divider />

          <b-dropdown-item
            link-class="d-flex align-items-center"
            to="business-settings"
          >
            <feather-icon
              size="16"
              icon="UserIcon"
              class="mr-50"
            />
            <span>Profile</span>
          </b-dropdown-item>

          <b-dropdown-divider />

          <b-dropdown-item
            link-class="d-flex align-items-center"
            @click="onClickLogout"
          >
            <feather-icon
              size="16"
              icon="LogOutIcon"
              class="mr-50"
            />
            <span>Logout</span>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </div>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar, BTooltip,
} from 'bootstrap-vue'
import NotificationDropdown from '@/@core/layouts/components/app-navbar/components/NotificationDropdown.vue'
import NetworkSpeed from '@/@core/layouts/components/app-navbar/components/NetworkSpeed.vue'
import Dsr from '@/@core/layouts/components/app-navbar/components/Dsr.vue'
import {
  mapGetters,
  mapActions,
} from 'vuex'
import { appEnv } from '@/constants/config'
import { computed } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import GeneralSearch from '@/@core/layouts/components/app-navbar/components/GeneralSearch.vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const BusinessRepository = RepositoryFactory.get('businessSettings')

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BTooltip,
    NotificationDropdown,
    NetworkSpeed,
    GeneralSearch,
    Dsr,
  },
  setup() {
    const { skin } = useAppConfig()
    const isDark = computed(() => skin.value === 'dark')

    const toggleTheme = () => {
      skin.value = isDark.value ? 'light' : 'dark'
    }

    return { isDark, toggleTheme }
  },
  data() {
    return {
      merchant: '',
      form: {},
      appEnv,
      boundary: 'viewport',
    }
  },
  computed: {
    ...mapGetters(['currentUser']),
  },
  // eslint-disable-next-line vue/order-in-components
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  mounted() {
    this.getBusinessSetting()
  },
  methods: {
    ...mapActions(['logout']),
    async onClickLogout() {
      // eslint-disable-next-line no-underscore-dangle
      this.__clearCache()
      await this.logout()
    },
    refreshCache() {
      // eslint-disable-next-line no-underscore-dangle
      this.__clearCache()
      window.location.reload()
    },
    async getBusinessSetting() {
      try {
        const data = localStorage.getItem('businessSettings') ? JSON.parse(localStorage.getItem('businessSettings')) : (await BusinessRepository.getBusinessSettigs()).data.data
        if (!localStorage.getItem('businessSettings')) localStorage.setItem('businessSettings', JSON.stringify(data))
        this.form = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    handleCickForWaybill() {
      this.$router.push('/waybill-request')
    },
  },
}
</script>
<style lang="css" scoped>

.tracking-icon{
  height:22px;
  width: 22px;
  margin-left: 5px;
    margin-right: 5px;
}
.calculator-icon{
  height:25px;
  width: 25px;
  margin-left:3px;
}
.business-title {
  justify-content: flex-start;
  font-size: 20px;
  display: flex;
  align-items: center;
}
.file-icon{
  color: white;
  width: 22px;
  height: 22px;
  margin-left: 5px;
  margin-right: 5px;
}
.cursor-pointer{
  width: 22px;
  height: 22px;
}
.no-hover {
  background-color: transparent !important;
  color: inherit !important;
  pointer-events: none; /* Disable hover effects */
}

.no-hover:hover,
.no-hover:focus,
.no-hover:active {
  background-color: transparent !important;
  color: inherit !important;
}

@media (max-width: 768px) {
  .navbar-scrollable {
    display: flex;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    white-space: nowrap;
    max-width: 100%;
    scrollbar-width: none;
  }

  .navbar-scrollable::-webkit-scrollbar {
    display: none;
  }

  .navbar-scrollable .navbar-nav {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
  }

  .navbar-nav .nav-item {
    flex-shrink: 0;
    margin-right: 10px;
  }

  .navbar-container {
    width: 100%;
  }

  .menu-icon,
  .navbar-container img,
  .navbar-container .file-icon,
  .navbar-container feather-icon {
    width: 15px;
    height: 15px;
    margin: 0 4px;
  }

  .mobile-avatar {
    width: 20px !important;
    height: 20px !important;
  }
  .b-tooltip {
    max-width: 100%;
    white-space: normal;
  }
}
</style>
